import dayjs, { Dayjs } from 'dayjs'
import { WaitingRoom } from '@/core/models/waiting-room.model'
import { getMinutesFromTimeString } from '@/utils/helpers'

/** True when `now` falls inside one of the waiting room's opening periods for that week day. */
export function isWaitingRoomOpenAt(waitingRoom: Pick<WaitingRoom, 'openingHours'>, now: Dayjs = dayjs()): boolean {
  const today = waitingRoom.openingHours?.find(({ day }) => day === now.day())
  const minutes = now.hour() * 60 + now.minute()
  return !!today?.periods.some((period) => minutes >= getMinutesFromTimeString(period.open) && minutes <= getMinutesFromTimeString(period.close))
}
